import React from "react";
import { Button, Modal } from "react-bootstrap";
import "./modal.scss";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../../../redux/actions/authActions";
export const LogoutModal = ({ show, handleClose }) => {
  const dispatch = useDispatch();
  const navigate = useHistory();
  const handlelogout = () => {
    dispatch(logout(navigate));
  };
  return (
    <div>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Sign Out</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to sign out</Modal.Body>
        <Modal.Footer>
          <Button
            className="w-full !rounded-md bg-transparent h-[43px] !max-w-28 !border-b-color text-black !text-sm hover:opacity-80"
            variant="secondary"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            className="w-full !rounded-md !max-w-28 !text-sm !bg-primary-blue h-[43px] !border-primary-blue hover:opacity-80"
            onClick={handlelogout}
            variant="primary"
          >
            Sign Out
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
